/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Korean
export default {
  'confluence-analytics-byline.abbreviated-user-views.message': '{count, plural, =0 {조회수} other {{count}}}',
  'confluence-analytics-byline.page-viewers.message': '조회자',
  'confluence-analytics-byline.user-views.message': '{count, plural, =0 {분석} other {조회한 사용자 {count}명}}',
};
